import * as angular from 'angular';
import AppConstants from '../gorillaboy/AppConstants';

angular.module('GorillaBoy')
.controller('createFolderCtrl', [
    '$scope',
    '$rootScope',
    'authenticatedUser',
    'FileService',
    'fileManagerInstance',
    'ParentFolderId',
    'MessageProvider',
    'SignalProvider',
    function createFolderCtrl($scope, $rootScope, authenticatedUser, FileService, fileManagerInstance, ParentFolderId, MessageProvider, SignalProvider) {
        $scope.modals = {};
        $scope.modals.folderName = '';
        $scope.clearFolderErrorText = function() {
            $scope.folderErrorText = '';
        };

        // call from clicking create folder button in the title bar of file list view
        $scope.createFolder = function() {
            var folderName = $scope.modals.folderName;
            if (!ParentFolderId) {
                ParentFolderId = authenticatedUser.getUserInfo().RootFolderId;
            }

            if (!folderName || folderName.length === 0) {
                $scope.folderErrorText = MessageProvider.folderCreateFailNotBlank;
                $scope.modals.folderName = '';
                return;
            } else if (folderName.length > AppConstants.LIMITS.RESOURCE_NAME_CHAR_LIMIT) {
                $scope.folderErrorText = MessageProvider.folderCreateFailNameLength;
                return;
            }
            // Create the form field so that the next time the modal is opened the name is blank.
            FileService.createFolder(folderName, ParentFolderId)
            .then(function(folderResult) {
                $scope.modals.folderName = '';
                if (fileManagerInstance && fileManagerInstance.getCurrentFolder() === ParentFolderId) {
                    var newFolderList = fileManagerInstance.getFolders().slice();
                    newFolderList.unshift(folderResult.Folder.Metadata);                            
                    fileManagerInstance.setFolders(newFolderList);
                    $rootScope.$broadcast(SignalProvider.Folder.SyncCurrentView);
                } else {
                    var redirectUrl = '';
                    if (ParentFolderId === authenticatedUser.getUserInfo().RootFolderId) {
                        redirectUrl = '/mydocs?highlightResourceId=' + folderResult.Folder.Metadata.Id;
                    } else {
                        redirectUrl = '/folder/' + ParentFolderId + '?highlightResourceId=' + folderResult.Folder.Metadata.Id;
                    }
                    $scope.goto(redirectUrl);
                }
                $scope.$close();
            }, function(data) {
                // Add an error for folder creation failure to the notification list.
                if (data.result && data.result.status === 409) {
                    // EntityAlreadyExistsException
                    $scope.folderErrorText = MessageProvider.folderCreateFailAlreadyExists(data.result.config.data.FolderName);
                } else if (data.result && data.result.status === 404 && data.message && data.message.indexOf('EntityNotExistsException') >= 0) {
                    // EntityNotExistsException cannot be uniquely identified by status code. no permission also return 404
                    $scope.folderErrorText = MessageProvider.folderCreateFailNotExists;
                } else if (data.result && data.result.status === 400) {
                    // ValidationException
                    $scope.folderErrorText = MessageProvider.renameInvalidName;
                } else {
                    $scope.folderErrorText = MessageProvider.folderCreateFailDefault;
                }
            });
        };
    }
]);